module.exports = {
	"status": {
		"unknown": null,
		"entwurf": null,
		"online": {
			"variant": "warning",
			"title": "Hinweis",
			"text": "Bei Klick auf „Bestätigen“ wird die Seite auf www.erco.com veröffentlicht. Dieser Vorgang kann bis zu 10 Minuten dauern."
		},
		"kopiert": null,
		"löschmarkiert": null,
		"archiv": {
			"variant": "warning",
			"title": "Hinweis",
			"text": "Bei Klick auf „Bestätigen“ wird die Seite archiviert."
		},
		"synchronize": null
	},
	"header": {
		"renewOnlineButton": {
			"variant": "warning",
			"title": "Hinweis",
			"text": "Über den Online-Erneuern Button können Inhalte vom Stagingserver auf www.erco.com übertragen werden. Änderungen, die an Objekten mit Status 'Online' vorgenommen werden, können so auf www.erco.com online gestellt werden."
		},
		"renewPreviewButton": {
			"variant": "warning",
			"title": "Hinweis",
			"text": "Über den Preview-Erneuern Button werden im CMS veränderte Inhalte eines Objekts auf dem Stagingserver zur Preview ausgespielt."
		},
		"createPreviewButton": {
			"variant": "warning",
			"title": "Hinweis",
			"text": "Über den Preview-Erneuern Button werden im CMS veränderte Inhalte eines Objekts auf dem Stagingserver zur Preview ausgespielt."
		},
		"clearCacheButton": {
			"variant": "warning",
			"title": "Hinweis",
			"text": "Über den Cache-Leeren Button wird der zwischengespeicherte (gecachte) Inhalt dieses Objekts auf dem Stagingserver gelöscht. Beim nächsten Aufruf der Seite wird der Inhalt neu erzeugt. Nützlich, wenn auf der Preview noch veraltete oder fehlerhafte Inhalte angezeigt werden."
		}
	},
	"setup": {
		"lastchanges": null,
		"objectname": {
			"variant": "info",
			"title": "Info",
			"text": "Der Objektname dient der Auffindbarkeit im CMS und wird für die Bildung der URL benutzt. Er sollte nicht mehr als {{maxChars}} Zeichen umfassen. Im Light Scout wird bei Ansichten mit wenig Platz (z.B. Slideshow/Raster/Mobil) der Objektname statt der Headline genutzt."
		},
		"pdbKey": null,
		"objectadditional": {
			"variant": "info",
			"title": "Info",
			"text": "Der Objektzusatz dient nur als Infofeld im Backend."
		},
		"objecteditor": {
			"variant": "info",
			"title": "Info",
			"text": "Hier muss der zuständige Redakteur (Gruppe Content) angegeben werden"
		},
		"objectdesigner": {
			"variant": "info",
			"title": "Info",
			"text": "Hier muss der zuständige Designer (Gruppe Media) angegeben werden"
		},
		"specification": {
			"variant": "info",
			"title": "Info",
			"text": "Die Spezifikation gibt den Hauptbereich auf der Website an wie Produkte-Innenraum, Projekte oder Anwendungen planen."
		},
		"basisgenus": {
			"variant": "info",
			"title": "Info",
			"text": "Die Stammgattung legt die Grundzuordnung eines Objekts zu einem Bereich wie Leuchtengattung, Projekt-Cluster oder Storieskategorie fest."
		},
		"categories": {
			"variant": "info",
			"title": "Info",
			"text": "Tags können auf Objekte gelegt werden, u.a. um eine Zuordnung zu Themengebieten oder Filterauswahlen zu ermöglichen. Tags werden auch für die Marketing-Automation genutzt. CMS-Objekte können darüber zu den Kriterien Cluster, Marktsegemente, Interessen und Funneltiefef für die Emarsys-Anbindung zugeordnet werden. Die Tags werden beim Generieren als JS-Variable im Seitencode hinterlegt."
		},
		"mediaformats": {
			"variant": "info",
			"title": "Info",
			"text": "Medienformate klassifizieren Inhalte der Stories-Seite."
		},
		"triad": {
			"variant": "info",
			"title": "Info",
			"text": "Über den Dreiklang können Verknüpfungen von Projekten und Produkten gepflegt werden."
		},
		"linkedProducts": {
			"variant": "info",
			"title": "Info",
			"text": "Über Verwendete Produkte können Verknüpfungen von Produkten gepflegt werden."
		},
		"startpage": {
			"variant": "info",
			"title": "Info",
			"text": "Über diese Radioboxen kann festgelegt werden, wo das Objekt in den Slider-Elementen auf der Startseite angezeigt werden soll."
		},
		"lightscoutClassification": {
			"variant": "info",
			"title": "Info",
			"text": "Über diese Checkboxen kann festgelegt werden, in welchen Sprachen das Objekt im Light Scout verfügbar sein soll."
		},
		"status": {
			"variant": "info",
			"title": "Info",
			"text": "Über den Status wird gesteuert, ob ein Objekt online geht.\nEntwurf= Initales Anlegen, Erstellen und Einpflegen\nOnline= Sofern der Veröffentlichungszeitraum erreicht ist, erscheint das Objekt auf www.erco.com)"
		},
		"publishdatetime": {
			"variant": "info",
			"title": "Info",
			"text": "Wenn ein Veröffentlichungsdatum gesetzt wird, geht das CMS-Objekt automatisch zu dem Zeitpunkt online."
		},
		"gooffdatetime": {
			"variant": "info",
			"title": "Info",
			"text": "Wenn ein Datum für das Offlinesetzen gesetzt wird, geht das CMS-Objekt automatisch zu dem Zeitpunkt offline."
		},
		"process": {
			"variant": "info",
			"title": "Info",
			"text": "Über die Prozess-Dropdowns können Stati zur Qualitätsprüfung gesetzt werden, sowie Benachrichtigungsmails an Prozessbeteiligte ausgelöst werden."
		},
		"visibility": {
			"variant": "info",
			"title": "Info",
			"text": "Ist diese Checkbox gesetzt, wird das Objekt in der Light Scout Suche angezeigt."
		},
		"synchblock": {
			"variant": "info",
			"title": "Info",
			"text": "Ist diese Checkbox gesetzt, wird eine Synchsperre für dieses Objekt gesetzt. Es wird dann nicht auf die prod-Umgbung gesynched."
		}
	},
	"objectdata": {
		"headline": {
			"variant": "info",
			"title": "Info",
			"text": "Die Headline enthält die Haupüberschrift des Objekts, umfasst maximal {{maxChars}} Zeichen und wird in der Regel in der Headerbar auf der Website angezeigt."
		},
		"subheadline": {
			"variant": "info",
			"title": "Info",
			"text": "Die Subheadline enthält den Untertitel des Objekts, umfasst maximal {{maxChars}} Zeichen und wird in der Regel in der Headerbar auf der Website angezeigt."
		},
		"teasertext": {
			"variant": "info",
			"title": "Info",
			"text": "Der Teasertext umfasst maximal {{maxChars}} und wird an unterschiedlichen Stellen genutzt u.a. in der Suche oder auf der Storiesseite in den Objektboxen. Er wird i.d.R. auch als Meta-Description-Text genutzt."
		},
		"projekteVeröffentlichungsdatumTtmmyyyyBzwSprachabhängig": {
			"variant": "info",
			"title": "Info",
			"text": "Das hier angegebene Veröffentlichungsdatum dient lediglich zur Anzeige auf der Website."
		},
		"event": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe unter Event wird in den Credits auf der Website angezeigt und kann für Ausstellungen, Messen usw. genutzt werden."
		},
		"bauherr": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"architektur": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"innenarchitektur": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"lichtplanung": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"elektroplanung": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"fotografie": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"ort": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"website": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"linksYoutubeEtcVimeoId": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird genutzt um Filmreferenzen zu vorzuhalten, die in spezifischen Templates genutzt werden. Für Youtube bitte nur die Video-ID eingeben aus der EmbedURL https://youtu.be/sClIaF1HyR4 (ID=sClIaF1HyR4)"
		},
		"veröffentlichungsdatumTtmmyyyyBzwSprachabhängig": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"latitudeNurZahlBsp52500833": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird u.a. genutzt, um in Kartendarstellungen Marker zu positionieren."
		},
		"longitudeNurZahlBsp52500833": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird u.a. genutzt, um in Kartendarstellungen Marker zu positionieren."
		},
		"googleMapsKurzlinkBspHttpgooglmapsoj0e": {
			"variant": "info",
			"title": "Info",
			"text": "Die Angabe wird in den Credits auf der Website angezeigt."
		},
		"metaTitle": {
			"variant": "info",
			"title": "Info",
			"text": "Der Meta-Title sollte maximal {{maxChars}} Zeichen umfassen, seitenspezifisch und einzigartig sein und wichtige Content-Keywords beinhalten."
		},
		"metaDescription": {
			"variant": "info",
			"title": "Info",
			"text": "Die Meta-Description sollte {{maxChars}} Zeichen umfassen und Content-Keywords beinhalten. Sie wird in der SERP angezeigt und sollte den Nutzer auffordern, die Seite anzuklicken."
		},
		"seoNoindex": {
			"variant": "info",
			"title": "Info",
			"text": "Wenn diese Seite nicht von Suchmaschinen indiziert werden soll, bitte die Einstellung 'ja' wählen."
		},
		"shorturl": {
			"variant": "info",
			"title": "Info",
			"text": "Short-URLs ohne Sprachkürzel führen immer zu EN oder zu der einen Sprache, der sie einzeln zugeordnet sind. Mehrere Short-URLs können getrennt durch Pipes \"|\" angegeben werden."
		},
		"rewriteId": {
			"variant": "info",
			"title": "Info",
			"text": "In dieses Feld kann eine CMS-Id eingetragen werden zu der die Urls dieses Objekt umgeleitet werden können. Das kann für offline gestellte Objekte genutzt werden."
		},
		"canonicalId": {
			"variant": "info",
			"title": "Info",
			"text": "In dieses Feld kann eine CMS-Id eingetragen werden über die eine Canonicalurl für dieses Objekts erzeugt wird, sofern dieses Objekt auf 'noindex' gesetzt ist (siehe oben)."
		}
	},
	"assets": {
		"editAsset": null,
		"teaserbild": {
			"variant": "info",
			"title": "Info",
			"text": "Das Teaserbild wird i.d.R. im Seitenkopf bei Reportagenlayouts etc. angezeigt."
		},
		"heroslider": {
			"variant": "info",
			"title": "Info",
			"text": "Das Heroslider-Bild ist ein querformatiges screenfüllendes Format."
		},
		"stellvertreterbild": {
			"variant": "info",
			"title": "Info",
			"text": "Das Stellvertreterbild wird in der Trefferliste der Light Scout-Suche und auf den diversen Übersichtsseiten (u.a. Clusterseiten) angezeigt."
		},
		"multiformat": {
			"variant": "info",
			"title": "Info",
			"text": "Das Multiformat-Bild bietet eine Beschnittauswahl in unterschiedliche Quer- oder Hochformate an."
		},
		"slideshowbild_2": null,
		"slideshowbild_3": null,
		"slideshowbild_4": null,
		"slideshowbild_5": null,
		"slideshowbild_6": null,
		"slideshowbild_7": null,
		"slideshowbild_8": null,
		"slideshowbild_9": null,
		"querformat_1920px816pxvideostill": {
			"variant": "info",
			"title": "Info",
			"text": "Diese Bild wird als Video Still verwendet."
		},
		"querformat_1920px1080pxvideostill": {
			"variant": "info",
			"title": "Info",
			"text": "Diese Bild wird als Video Still verwendet."
		},
		"querformat_830px415px": {
			"variant": "info",
			"title": "Info",
			"text": "Diese Bild wird als Video Still verwendet."
		}
	},
	"layout": {
		"createNewSite": null,
		"itemEdit": null,
		"presets": {
			"reportagen-template": {
				"variant": "info",
				"title": "Info",
				"text": "Template für Reportagen"
			},
			"kurzgeschichten-template": {
				"variant": "info",
				"title": "Info",
				"text": "Template für Kurzgeschichten"
			},
			"highlight-template": {
				"variant": "info",
				"title": "Info",
				"text": "Template für Highlights"
			},
			"fachartikel-template": {
				"variant": "info",
				"title": "Info",
				"text": "Template für Fachartikel"
			},
			"default-template": {
				"variant": "info",
				"title": "Info",
				"text": "Template mit Footer und Header"
			}
		}
	},
	"misc": {
		"imageEditor": null
	}
};


//////////////////
// WEBPACK FOOTER
// ./static/json/hilfe_texte.json
// module id = 683
// module chunks = 0